// Subscribe a component to the global connectivity/sync signal.
// Returns { status: 'online' | 'syncing' | 'offline', pending: number,
// owed: { answer, rating, other } }. `owed` counts the writes the queue gave up
// on that the player has not been told about yet, by what was lost. Whoever
// tells them calls acknowledgeLoss with what it showed.

import { useSyncExternalStore } from 'react';
import {
  subscribeConnectivity,
  getConnectivitySnapshot,
  acknowledgeLoss,
} from '../utils/connectivity';

export { acknowledgeLoss };

export function useConnectivity() {
  return useSyncExternalStore(
    subscribeConnectivity,
    getConnectivitySnapshot,
    getConnectivitySnapshot,
  );
}

export default useConnectivity;
